module.exports = __webpack_public_path__ + "img/Background.8006e1d0.jpeg";